import Marionette from 'backbone.marionette';
import billDetailLayoutTmpl from '../templates/bill_detail_layout.tpl';
export default Marionette.LayoutView.extend({
  template: billDetailLayoutTmpl,
  className: "container",
  regions: {
    billRegion: "#bill-region",
    storyRegion: "#story-region",
    authorRegion: "#primary-author-region",
    coauthorsRegion: "#coauthors-region",
    statusRegion: "#status-region",
    versionRegion: "#version-region",
    voteRegion: "#vote-region"
  }
});